import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import Catalog from './pages/Catalog';
import GiftCardDetail from './pages/GiftCardDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <div className="min-h-screen bg-gray-50 flex flex-col">
            <a href="#main-content" className="skip-to-content">
              Skip to main content
            </a>
            <Navbar />
            <main
              id="main-content"
              className="flex-grow"
              tabIndex="-1"
              aria-label="Main content"
            >
              <Routes>
                <Route
                  path="/"
                  element={
                    <ErrorBoundary>
                      <Home />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/catalog"
                  element={
                    <ErrorBoundary>
                      <Catalog />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/catalog/:id"
                  element={
                    <ErrorBoundary>
                      <GiftCardDetail />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/cart"
                  element={
                    <ErrorBoundary>
                      <Cart />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/checkout"
                  element={
                    <ErrorBoundary>
                      <Checkout />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <ErrorBoundary>
                      <Dashboard />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ErrorBoundary>
                      <AdminDashboard />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/login"
                  element={
                    <ErrorBoundary>
                      <Login />
                    </ErrorBoundary>
                  }
                />
                <Route
                  path="/register"
                  element={
                    <ErrorBoundary>
                      <Register />
                    </ErrorBoundary>
                  }
                />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
